module.exports = __webpack_public_path__ + "static/media/Commercial_Hydroponic_Img.a95f0ce2.webp";